import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import store, { persistor } from '../../../js/lib/redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import ModifyRouter from '../../router/ModifyRouter'
import { bookingSlice } from '../../../js/lib/redux/slices/booking'

const Modify = () => {
  useEffect(() => {
    // Check if this is a page refresh or navigation from another page
    const navigationType = performance.getEntriesByType('navigation')[0]?.type
    const isPageRefresh = navigationType === 'reload'

    if (!isPageRefresh) {
      // Navigation from another page - clear old reservation data
      // This prevents cross-reservation contamination
      persistor.purge().then(() => {
        store.dispatch(bookingSlice.actions.reset())
      })
    }
    // else: Page refresh (F5) - keep persisted state including comments
    // Note: For static pages without server-side routing, this won't trigger
    // as refreshing a route will 404. But for dynamic sites, this preserves state on refresh.
  }, [])

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ModifyRouter />
      </PersistGate>
    </Provider>
  )
}

export default Modify
